import Root from './root'
import Stats from './parts/stats/stats'
import Sort from './parts/sort/sort'
import Results from './parts/results/results'
import CurrentRefinements from './parts/current-refinements/current-refinements'
import Price from './parts/price/price'
import Taxonomy from './parts/taxonomy/taxonomy'
import Features from './parts/features/features'
import Audiences from './parts/audiences/audiences'
import Brand from './parts/brand/brand'
import Offers from './parts/offers/offers'

function Side({ brand, mini, skipAudiences, defaultRefinement }) {
    return (
        <>
            <Price />
            <Taxonomy defaultRefinement={defaultRefinement} />
            <Features />
            {!skipAudiences && <Audiences />}
            {!mini && (
                <>
                    <Brand brand={brand} />
                    <Offers />
                </>
            )}
        </>
    )
}

function Meta() {
    return (
        <div className="ais-Meta mb30">
            <Stats />
            <Sort />
        </div>
    )
}

export default function Products({ mini, account, brand, filter, hideRating, skipAudiences, defaultRefinement }) {
    return (
        <Root
            account={account}
            filter={filter}
            side={
                <Side mini={mini} skipAudiences={skipAudiences} defaultRefinement={defaultRefinement} brand={brand} />
            }
            meta={<Meta />}
        >
            <CurrentRefinements />
            <Results hideRating={hideRating} />
        </Root>
    )
}
